if($('body.mobile .shippingMethod.haveButton').length){
    $('.shippingMethod .inner').each(function() {
        const textBlock = $(this).find('.text');
        textBlock.find('p').first().after('<p class="mobileButton"><span>'+cistVice+'</span></p>');
        textBlock.find('.mobileButton').nextAll().hide();
    });
}

$('html').on('click', '.mobileButton', function() {
    const buttonText = $(this);
    const container = $(this).closest('.text');
    container.find('.mobileButton').nextAll().slideToggle();
    container.toggleClass('openDeliveryInfo');
    if (container.hasClass('openDeliveryInfo')) {
        buttonText.text(cistMene);
    } else {
        buttonText.text(cistVice);
    }
});